import axiosConfig from '@/utils/axiosConfig'

// 非小游戏内情形下获取当前用户信息
export function getConfigData (data) {
    return axiosConfig({
        method: 'post',
        url: '/web/config/query',
        data,
    })
}
